import { Controller } from "@hotwired/stimulus"

const FA_DIGITS = "۰۱۲۳۴۵۶۷۸۹"

// Backs UI::MoneyFieldComponent: live-formats the visible text field with
// Persian thousands separators as the admin types, while keeping a hidden
// field (the one actually submitted, under the real attribute name) synced
// to the plain digits — decimal DB columns can't parse "٬" delimiters or
// Persian digits. Formatting logic mirrors profit_calculator_controller's
// formatFa/parseAmount.
export default class extends Controller {
  static targets = ["display", "raw"]

  connect() {
    // Decimal DB columns serialize as e.g. "25000000000.0" — route the
    // initial value through parseAmount too, not just formatFa, so the
    // fractional part is dropped rather than merged into the integer.
    const amount = this.parseAmount(this.rawTarget.value)
    this.rawTarget.value = amount
    this.displayTarget.value = amount ? this.formatFa(amount) : ""
  }

  onInput() {
    const amount = this.parseAmount(this.displayTarget.value)
    this.rawTarget.value = amount
    this.displayTarget.value = amount ? this.formatFa(amount) : ""
  }

  // Rial amounts are treated as whole numbers throughout this app (see
  // profit_calculator_controller) — the integer part is kept and any
  // fractional part (from a decimal DB column, or a stray "." typed by a
  // user) is dropped, rather than merged into the integer digit-wise.
  parseAmount(raw) {
    const integerPart = this.toEnDigits(raw).split(/[.٫]/)[0]
    const digits = integerPart.replace(/[^\d]/g, "")
    return digits ? parseInt(digits, 10) : ""
  }

  // Input may contain Persian digits (typed directly, or left over from a
  // previous formatFa render) — JS's \d only matches ASCII 0-9, so these
  // must be normalized before parsing.
  toEnDigits(value) {
    return value.replace(/[۰-۹]/g, (digit) => String(FA_DIGITS.indexOf(digit)))
  }

  formatFa(value) {
    if (value === "" || value === null || value === undefined) return ""

    const withDelimiters = Number(value).toLocaleString("en-US").replaceAll(",", "٬")
    return withDelimiters.replace(/[0-9]/g, (digit) => FA_DIGITS[digit])
  }
}
